module.exports = "<div class=\"group-plugin just-padding\" v-if=\"currentGroup !== undefined\"> \r\n    <tree-list :groups=\"groups\" :options=\"options\"/>\r\n</div>\r\n<loading-spinner v-else/>"


//////////////////
// WEBPACK FOOTER
// ./src/views/tree/tree.html
// module id = 21
// module chunks = 0